import CheckmateApiClient from '../../../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useGetAlertSummary = () => {
    return useQuery({
        queryKey: ['get-alert-summary'],
        queryFn: async () => {
            const response = await _apiClient.getAlertBarInfo();

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve alert summary.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        cacheTime: 0,
        staleTime: 0,
    });
};
